import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosConfig";
import { AuthContext } from "../../context/AuthContexto";
import { Card, Form, Button, Spinner, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import logo from "../../logo.png";
//prueba
function LoginPag() {
  const { login } = useContext(AuthContext);
  const [celular, setCelular] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!celular || !contrasena) {
      toast.warning("⚠️ Ingresa celular y contraseña");
      return;
    }

    setLoading(true);
    try {
      console.log("BASE URL AXIOS:", api.defaults.baseURL);
      const res = await api.post("/usuarios/login", { celular, contrasena });

      const { token, usuario } = res.data;

      if (!token || !usuario) {
        toast.error("❌ Error en la respuesta del servidor");
        setLoading(false);
        return;
      }

      login(usuario, token);

      toast.success(`Bienvenido ${usuario.nombre} (${usuario.rol})`);

      setTimeout(() => {
        switch (usuario.rol) {
          case "ADMIN":
            navigate("/usuarios");
            break;
          case "CAJERO":
            navigate("/facturas");
            break;
          case "MESERO":
          case "COCINA":
            navigate("/pedidos");
            break;
          default:
            navigate("/pedidos");
        }
      }, 800);
    } catch (error) {
      const status = error.response?.status;
      if (status === 401) toast.error("❌ Contraseña incorrecta");
      else if (status === 404) toast.error("❌ Usuario no encontrado");
      else toast.error("⚠️ Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100 py-3 py-md-0"
      style={{ background: "linear-gradient(135deg, #4939a7, #531515)" }}
    >
      <ToastContainer position="top-center" autoClose={3000} />

      <Card
        className="shadow-lg overflow-hidden animate__animated animate__fadeIn"
        style={{
          width: "100%",
          maxWidth: "900px",
          borderRadius: "20px",
          backgroundColor: "#fff",
          margin: "0 16px", // margen lateral en móvil
        }}
      >
        <Row className="g-0 flex-column flex-md-row">
          {/* 🔸 LADO IZQUIERDO - LOGO (solo en md en adelante con fondo) */}
          <Col
            md={6}
            className="d-none d-md-flex flex-column justify-content-center align-items-center"
            style={{
              background:
                "url('https://images.unsplash.com/photo-1606756790138-261f98b43c31?auto=format&fit=crop&w=900&q=80') center/cover",
              position: "relative",
            }}
          >
            <img
              src={logo}
              alt="Delis Tu Merienda Logo"
              className="animate__animated animate__zoomIn"
              style={{
                width: "400px",
                height: "400px",
                objectFit: "contain",
                filter: "drop-shadow(0 0 12px rgba(0,0,0,0.4))",
              }}
            />
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "15%",
                height: "70%",
                width: "4px",
                background:
                  "linear-gradient(to bottom, #FFD700, #FFC300, #FFD700)",
                borderRadius: "2px",
              }}
            ></div>
          </Col>

          {/* 🔹 LADO DERECHO - FORMULARIO */}
          <Col
            md={6}
            className="d-flex flex-column justify-content-center p-4 p-md-5"
          >
            {/* Logo versión móvil (se muestra solo en pantallas pequeñas) */}
            <div className="d-flex d-md-none justify-content-center mb-3">
              <img
                src={logo}
                alt="Delis Tu Merienda Logo"
                style={{
                  width: "180px",
                  height: "180px",
                  objectFit: "contain",
                  filter: "drop-shadow(0 0 8px rgba(0,0,0,0.3))",
                }}
              />
            </div>

            <div className="text-center mb-3 mb-md-4">
              <h3 className="fw-bold" style={{ color: "#4939a7" }}>
                Iniciar Sesión
              </h3>
              <p className="text-muted small d-none d-md-block">
                Ingresa con tu usuario asignado para gestionar pedidos y
                facturas.
              </p>
            </div>

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Celular</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  value={celular}
                  onChange={(e) => setCelular(e.target.value)}
                  placeholder="Ej: 3001234567"
                  style={{ borderRadius: "10px" }}
                  autoFocus
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  size="lg"
                  type="password"
                  value={contrasena}
                  onChange={(e) => setContrasena(e.target.value)}
                  placeholder="********"
                  style={{ borderRadius: "10px" }}
                />
              </Form.Group>

              <div className="d-grid mt-3">
                <Button
                  type="submit"
                  className="fw-bold text-dark"
                  style={{
                    borderRadius: "12px",
                    fontSize: "16px",
                    backgroundColor: "#FFD700",
                    border: "none",
                  }}
                  disabled={loading}
                  size="lg"
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Ingresar"
                  )}
                </Button>
              </div>
            </Form>

            <p className="text-center text-muted mt-4 mb-0 small">
              © {new Date().getFullYear()} El Parche Accesories. Todos los derechos
              reservados.
            </p>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default LoginPag;
